import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Stack, Paper, Container } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { getHome, getProdsuctImage } from "../services/api/homeApi"; // adjust path if needed
import { useNavigate } from "react-router-dom";

export default function OurProducts() {
  const [homeData, setHomeData] = useState(null);
  const navigate = useNavigate();
  const [productImages, setProductImages] = useState([]);

  useEffect(() => {
    const fetchHome = async () => {
      try {
        const data = await getHome();
        setHomeData(data);
        const images = await getProdsuctImage(); // 👈 ADD
        setProductImages(images);
      } catch (error) {
        console.error("Failed to load home data", error);
      }
    };

    fetchHome();
  }, []);

  const animatedButtonSx = {
    borderRadius: "999px",
    px: 4,
    py: 1.2,
    textTransform: "none",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    overflow: "hidden",

    "&:hover .btn-text": {
      animation: "textFromTop 0.45s cubic-bezier(0.16,1,0.3,1)",
    },
    "& .btn-text": {
      animation: "textFromBottom 0.45s cubic-bezier(0.16,1,0.3,1)",
    },

    "&:hover .arrow-icon": {
      animation: "arrowIconIn 0.45s cubic-bezier(0.16,1,0.3,1)",
    },
    "& .arrow-icon": {
      animation: "arrowIconOut 0.45s cubic-bezier(0.16,1,0.3,1)",
    },

    "@media (max-width:900px)": {
      "& .btn-text, & .arrow-icon": {
        animation: "none !important",
        transform: "none",
        opacity: 1,
      },
    },
  };

  return (
    <Box sx={{ backgroundColor: "common.white", pb: { xs: 6, md: 10 } }}>
      <Container maxWidth="xl">
        <Paper
          elevation={0}
          sx={{
            maxWidth: "1440px",
            mx: "auto",
            px: { xs: 2, sm: 3, md: 3, lg: 15 },
            py: { xs: 4, sm: 5, md: 0 },
            borderRadius: { xs: 3, md: 4 },
            backgroundColor: "background.default",
          }}
        >
          {/* HEADING */}
          <Typography
            align="center"
            sx={{
              fontSize: { xs: 26, sm: 34, md: 48 },
              fontWeight: 800,
              color: "primary.main",
              mb: { xs: 4, md: 3 },
            }}
          >
            Our Products
          </Typography>

          {/* MAIN GRID */}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                md: "1.05fr 0.95fr",
              },
              gap: { xs: 5, md: 0 },
              alignItems: "center",
            }}
          >
            {/* IMAGE */}
            <Box sx={{ display: "flex", justifyContent: "flex-start", alignSelf: "flex-start", }}>
              <Box
                component="img"
                src={homeData?.product_image}
                alt="Puriffhygiene Pack"
                sx={{
                  width: "100%",
                  maxWidth: {
                    xs: 500,
                    sm: 700,
                    md: 380,
                    lg: 420,
                  },
                  height: "auto",
                   

                  objectFit: "cover",
                  borderRadius: { xs: "10px", sm: "24px", md: "28px" },
                }}
              />
            </Box>

            {/* CONTENT */}
            <Box sx={{ width: "100%", ml:3}}>
              <Box
                sx={{
                  fontSize: { xs: 14, sm: 15, md: 18 },
                  color: "text.secondary",
                  lineHeight: 1.7,
                  textAlign: "right",

                }}
                dangerouslySetInnerHTML={{
                  __html: homeData?.product_description || "",
                }}
              />

              {/* BUTTONS */}
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                my={2}
                justifyContent="center"

              >
                <Button variant="contained" onClick={() => navigate("/product")} sx={animatedButtonSx}>
                  <Box
                    className="btn-text"
                    
                    sx={{ cursor: "pointer" }}
                  >
                    Products
                  </Box>
                  <Box
                    sx={{
                      width: 34,
                      height: 34,
                      borderRadius: "50%",
                      backgroundColor: "background.light",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <ArrowForwardIcon
                      className="arrow-icon"
                      fontSize="small"
                      sx={{ color: "primary.main" }}
                    />
                  </Box>
                </Button>
                {/* 
                <Button variant="outlined" sx={animatedButtonSx}>
                  <Box className="btn-text">Where to Buy</Box>
                  <Box
                    sx={{
                      width: 34,
                      height: 34,
                      borderRadius: "50%",
                      backgroundColor: "primary.main",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <ArrowForwardIcon
                      className="arrow-icon"
                      fontSize="small"
                      sx={{ color: "primary.contrastText" }}
                    />
                  </Box>
                </Button> */}
              </Stack>

              {/* BADGES (static as before) */}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: {
                    xs: "repeat(2, 1fr)",
                    sm: "repeat(3, 1fr)",
                    md: "repeat(4, 1fr)",
                  },
                  gap: 2,
                  maxWidth: 460,
                  mx: "auto"
                }}
              >
                {productImages.map((item) => (
                  <Box
                    key={item.id}
                    sx={{
                      backgroundColor: "background.light",
                      borderRadius: 3,
                      height: { xs: 70, sm: 80 },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      component="img"
                      src={item.image} // 👈 API image
                      alt="product"
                      sx={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
